import { AlgoliaSearchClientRepository } from "@data/repositories/index";
import { SearchTableAttendClientsUseCase } from "@useCases/index";
import { algoliaIndex } from "@data/algolia/config";
import { Client } from "@domain/models/Client";
import { Filter } from "@domain/models/Filters";
import userStore from "@data/stores/user";
import { useState } from "react";

type AlgoliaResult = {
  clients: Client[];
  total: number;
};

export default function useAlgolia() {
  const [filteredResult, setFilteredResult] = useState<AlgoliaResult>({ clients: [], total: 0 });
  const [searchedResult, setsearchedResult] = useState<AlgoliaResult>({ clients: [], total: 0 });

  const algoliaFilter = async (filters: Filter[], page: number) => {
    const useCase = new SearchTableAttendClientsUseCase(
      userStore.getState(),
      new AlgoliaSearchClientRepository(algoliaIndex)
    );

    useCase.execute({ query: "", filters, page }).then((response) => {
      setFilteredResult({
        clients: response.clients,
        total: response.total,
      });
    });
  };

  const algoliaSearch = async (search: string, page: number) => {
    const useCase = new SearchTableAttendClientsUseCase(
      userStore.getState(),
      new AlgoliaSearchClientRepository(algoliaIndex)
    );

    useCase.execute({ query: search, filters: [], page }).then((response) => {
      setsearchedResult({
        clients: response.clients,
        total: response.total,
      });
    });
  };

  const algoliaSearchResult = async (search: string) => {
    const useCase = new SearchTableAttendClientsUseCase(
      userStore.getState(),
      new AlgoliaSearchClientRepository(algoliaIndex)
    );

    return useCase
      .execute({ query: search, filters: [], page: 0 })
      .then((response) => response.clients);
  };

  return {
    algoliaFilter,
    algoliaSearch,
    algoliaSearchResult,
    filteredResult,
    searchedResult,
  };
}
